module.exports = (__webpack_require__("bricks/presentational-bricks:/8r5"))("qJlv");